var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-banner"},[_c('img',{attrs:{"src":_vm.bannerUrl,"alt":"Header Banner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }